import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';

import { IconModule, PopoverDirective } from '@hglobal/fin-ui';

import { SafeHtmlPipe } from '@kr/pipes';
import { ClipboardService } from '@kr/services';

@Component({
  imports: [IconModule, PopoverDirective, SafeHtmlPipe],
  selector: 'kr-copy-tooltip',
  templateUrl: './copy-tooltip.component.html',
  styleUrls: ['./copy-tooltip.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CopyTooltipComponent {
  readonly clipboard = inject(ClipboardService);

  text = input<string>();
  iconName = input('info');
  copy = input(true);
}
